export default "__VITE_ASSET__98e3b1e6__"